import { useState, type FormEvent } from "react";
import { useForgotPassword } from "@refinedev/core";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export function RecoveryPage() {
  const { mutate, isPending } = useForgotPassword();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    mutate(
      { email },
      {
        onSuccess: () => {
          setSent(true);
          toast.success("Te enviamos un correo con instrucciones");
        },
        onError: (err) => toast.error("Error", { description: err.message }),
      },
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm card p-8 space-y-6">
        <header className="text-center space-y-2">
          <h1 className="text-2xl font-bold">Recuperar contraseña</h1>
          <p className="text-sm text-fg-secondary">
            Te enviamos un link al correo para que crees una nueva.
          </p>
        </header>

        {sent ? (
          <p className="text-center text-success">Revisa tu correo</p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1">
              <label htmlFor="email" className="text-sm font-medium">Correo</label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-md border border-border bg-bg-card px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-brand"
              />
            </div>
            <button type="submit" disabled={isPending} className="btn-primary w-full">
              {isPending ? "Enviando..." : "Enviar link"}
            </button>
          </form>
        )}

        <p className="text-center text-sm">
          <Link to="/login" className="text-brand hover:underline">
            Volver al login
          </Link>
        </p>
      </div>
    </div>
  );
}
